import type { ExperimentConfig } from '../@types'

// GT-4696 / DEV-34819 — per-funnel 3-level CR scoring. US-only audience; no funnel swap (unlike i1,
// walking no longer scores `reason`, so the control onboarding is enough).
const config: ExperimentConfig[] = [
	{
		'activity-female-walking': {
			// /result_complete?safe&mock-data&country=US&area=activity-female-walking&exp=web_ml_cr_scoring_3_level_i4_1~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_ml_cr_scoring_3_level_i4_1/walking_f'),
			},
		},
		'activity-female-tai-chi-walking-v2': {
			// /result_complete?safe&mock-data&country=US&area=activity-female-tai-chi-walking-v2&exp=web_ml_cr_scoring_3_level_i4_1~1
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_ml_cr_scoring_3_level_i4_1/tai_chi_walking_f_v2'),
			},
		},
		'activity-female-tai-chi-walking-pr': {
			// /result_complete?safe&mock-data&country=US&area=activity-female-tai-chi-walking-pr&exp=web_ml_cr_scoring_3_level_i4_1~1
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_ml_cr_scoring_3_level_i4_1/tai_chi_walking_f_pr'),
			},
		},
	},
]

export default config
